module.exports = __webpack_public_path__ + "9d8467273fd86292.svg";